export default "__VITE_ASSET__CLr$0MoP__"